import { useTranslation } from "react-i18next";
import { Folder } from "lucide-react";
import clsx from "clsx";
import { ValueName } from "../../ValueName";
import type { FolderLabelProps } from "./types";

export const FolderLabel = ({
  name,
  fileCode,
  planCount,
  iconSize,
  className,
}: FolderLabelProps) => {
  const { t } = useTranslation();

  return (
    <span className={clsx("flex w-full min-w-0 items-start gap-2", className)}>
      <span className="flex min-w-0 items-start gap-1.5">
        <Folder size={iconSize} className="mt-0.5 flex-shrink-0" />
        <ValueName name={name} fileCode={fileCode} />
      </span>
      {planCount !== null && (
        <span className="flex-shrink-0 whitespace-nowrap rounded bg-white px-2 py-0.5 text-xs font-medium">
          {t("smartSurveyor.folders.suggestion.planCount", {
            count: planCount,
          })}
        </span>
      )}
    </span>
  );
};
